export { IcodTag } from "./pages/icodTag";
